import Vue from "vue";
import main from '@/router/modules/main';
// import theme from '@/router/modules/theme';
import add_video from '@/router/modules/add_video';
import video_editor from '@/router/modules/video_editor';
import add_content from '@/router/modules/add_content';
import add_text from '@/router/modules/add_text';
import add_music from '@/router/modules/add_music';
import add_ending from '@/router/modules/add_ending';
import survey from "@/router/modules/survey";
import add_entry from '@/router/modules/entry';
import add_ending_select from '@/router/modules/add_ending_select';
import final from '@/router/modules/final';
import calendar from "@/router/modules/calendar";
import auth from '@/router/modules/auth/auth';
import auth_check_order from '@/router/modules/auth/auth-check-order'
import auth_code from '@/router/modules/auth/auth_code';
import auth_code_check_order from "@/router/modules/auth/auth_code_check_order";
import payment from "@/router/modules/payment";
import success from "@/router/modules/success";
import error from "@/router/modules/error";
import check_order from "@/router/modules/check_order";
import app_terms from "@/router/modules/app_terms";
import app_slider from "@/router/modules/add_slider";
import personal_data from '@/router/modules/info-pages/personal-data'
import return_policy from "@/router/modules/info-pages/return_policy";
import offer from "@/router/modules/info-pages/offer";
import Router from 'vue-router'
import Store from '../store/index.js'

Vue.use(Router)
Vue.use(Store)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        main,
        /* theme, */
        add_video,
        video_editor,
        add_content,
        add_text,
        add_music,
        add_ending,
        survey,
        add_entry,
        add_ending_select,
        final,
        calendar,
        auth,
        auth_check_order,
        auth_code,
        auth_code_check_order,
        payment,
        success,
        error,
        check_order,
        app_terms,
        app_slider,
        personal_data,
        return_policy,
        offer
    ]
})